import { render, staticRenderFns } from "./BasePhoneNumberField.vue?vue&type=template&id=aeb0e39e"
import script from "./BasePhoneNumberField.vue?vue&type=script&lang=js"
export * from "./BasePhoneNumberField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports